import { invert } from 'lodash-es'
import dayjs from 'dayjs'
import { onlinePlatformMap } from '../../../const'

export {
  switchMap
} from '@/utils/constants'

export {
  fileExtType,
  rightFileExtType,
  LEVEL_ONE_APPEAL,
  mediaTypeMap,
  appealPlatMap,

  APPEAL_STATUS,
  appealTypeMap,
  levelOneAppealMap,
  levelTwoAppealMap,

  ONLINE_PLATFORM,
  onlinePlatformMap,
  AUTH_TYPE,
  authTypeMap,
  RIGHT_FILE_TYPE,
  rightFileTypeMap,

  appealTypeLevelOneLevelTwoMap,
  getLevelOneMap,
  getLevelTwoMap,

  APPEAL_TYPE,
} from '../../../const'

const onlinePlatformLabelMap = invert(onlinePlatformMap)

export const noticeTemplateConfig = {
  音乐名称: {
    key: 'musicName',
    ph: '根据实际情况填写',
    format: val => val
  },
  认领时间: {
    key: 'claimTime',
    ph: 'xxxx/xx/xx',
    format: val => dayjs(val).format('YYYY-MM-DD')
  },
  歌手名: {
    key: 'singerName',
    ph: '根据实际情况填写',
    format: val => val
  },
  '版权(授权)方': {
    key: 'claimCompanyName',
    ph: '根据实际情况填写',
    format: val => val
  },
  授权类型: {
    key: 'authType',
    ph: '签约',
    format: val => val.includes('签约') ? 1 : 0
  },
  是否首发: {
    key: 'isOnly',
    ph: '是/否',
    format: val => val.includes('是') ? 1 : 0
  },
  首发天数: {
    key: 'onlyDuration',
    ph: '30/0',
    format: val => isNaN(+val) ? 0 : +val
  },
  是否维权: {
    key: 'canLegalRights',
    ph: '是/否',
    format: val => val.includes('是') ? 1 : 0
  },
  人工监控: {
    key: 'isMonitor',
    ph: '是/否',
    format: val => val.includes('是') ? 1 : 0
  },
  是否进付费包: {
    key: 'isPay',
    ph: '是/否',
    format: val => val.includes('是') ? 1 : 0
  },
  授权区域: {
    key: 'authArea',
    ph: '根据实际情况填写',
    format: val => val
  },
  上线平台: {
    key: 'onlinePlat',
    ph: 'TME（QQ音乐、酷狗音乐、酷我音乐）任填一个',
    format: val => Number(onlinePlatformLabelMap[val] ?? 0)
  },
  歌曲数量: {
    key: 'trackCount',
    ph: 'x首',
    format: val => isNaN(parseInt(val)) ? 0 : parseInt(val)
  },
  伴奏数量: {
    key: 'kTrackCount',
    ph: 'x首',
    format: val => isNaN(parseInt(val)) ? 0 : parseInt(val)
  },
  视频数量: {
    key: 'mvCount',
    ph: 'x支',
    format: val => isNaN(parseInt(val)) ? 0 : parseInt(val)
  },
  '合约归属（请填写框架合同号）': {
    key: 'contract',
    ph: '',
    format: val => val
  },
}
export const noticeParseTemplate = Object.entries(noticeTemplateConfig).map(([key, config]) => `${key}：${config.ph}`).join('\n\n')

export function parseTemplate(template) {
  const result = {}
  const lines = template.split(/[\r\n]+/)
  lines.forEach(line => {
    const [key, value] = line.split('：')
    const config = noticeTemplateConfig[key]
    if (config && value) {
      result[config.key] = config.format(value)
    }
  })
  return result
}
